import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import { FooterContactInfo } from './FooterContactInfo/FooterContactInfo';
import styles from './FooterControls.module.css';
import { FooterQuickLinks } from './FooterQuickLinks/FooterQuickLinks';
import { FooterVerse } from './FooterVerse/FooterVerse';

export type FooterControls = {
  className?: string;
};

export const FooterControls: FunctionComponent<FooterControls> = ({
  className,
}) => {
  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.desktop}>
        <FooterContactInfo />
        <div>{<FooterQuickLinks />}</div>
        <div className={styles.right}>
          <FooterVerse />
        </div>
      </div>
      <div className={styles.tablet}>
        <div className={styles.left}>
          <FooterContactInfo />
        </div>
        <div className={styles.right}>
          {<FooterQuickLinks />}
          <FooterVerse />
        </div>
      </div>
      <div className={styles.largePhone}>
        <div className={styles.top}>
          <FooterContactInfo />
        </div>
        <div className={styles.bottom}>
          {<FooterQuickLinks />}
          <FooterVerse />
        </div>
      </div>
      <div className={styles.smallPhone}>
        <div className={styles.top}>
          <FooterContactInfo />
        </div>
        <div className={styles.bottom}>
          {<FooterQuickLinks />}
          <FooterVerse />
        </div>
      </div>
    </div>
  );
};
